import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ContentHeadingComponent } from './content-heading/content-heading.component';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { ContentBodyComponent } from './content-body/content-body.component';
import { BreadcrumbsComponent } from './breadcrumbs/breadcrumbs.component';
import { RouterModule } from '@angular/router';
import { NavbarComponent } from './navbar/navbar.component';
import { ToastNotificationComponent } from './toast-notification/toast-notification.component';
import { NgbToastModule } from '@ng-bootstrap/ng-bootstrap';
import { NotificationPanelComponent } from './notification-panel/notification-panel.component';
import { TimeagoModule } from 'ngx-timeago';
import { FlexLayoutModule } from '@angular/flex-layout';
import { WizardLayoutComponent } from './wizard-layout/wizard-layout.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { StickyFooterComponent } from './sticky-footer/sticky-footer.component';
import { SubscriptionVersionSelectionComponent } from './subscription-version-selection/subscription-version-selection.component';
import { StatusSelectionComponent } from '../cloud-subscription/components/status-selection/status-selection.component';
import { TableComponent } from './table/table.component';
import { QoutationTableComponent } from 'ncache-common-library';
import { ComboBoxComponent } from './combo-box/combo-box.component';
import { ReadonlyInputComponent } from '../connection/common/readonly-input/readonly-input.component';
import { ClipboardCopyComponent } from './clipboard-copy/clipboard-copy.component';
import { HelpPanelComponent } from './help-panel/help-panel.component';

@NgModule({
  declarations: [
    ContentHeadingComponent,
    ContentBodyComponent,
    BreadcrumbsComponent,
    NavbarComponent,
    ToastNotificationComponent,
    NotificationPanelComponent,
    HelpPanelComponent,
    WizardLayoutComponent,
    StickyFooterComponent,
    SubscriptionVersionSelectionComponent,
    StatusSelectionComponent,
    TableComponent,
    ComboBoxComponent,
    ReadonlyInputComponent,
    ClipboardCopyComponent
  ],
  imports: [
    CommonModule,
    FontAwesomeModule,
    RouterModule,
    NgbToastModule,
    ReactiveFormsModule,
    FlexLayoutModule,
    TimeagoModule,
    FormsModule,
  ],
  exports: [
    ContentHeadingComponent,
    ContentBodyComponent,
    BreadcrumbsComponent,
    NavbarComponent,
    ComboBoxComponent,
    ToastNotificationComponent,
    NotificationPanelComponent,
    WizardLayoutComponent,
    HelpPanelComponent,
    StickyFooterComponent,
    SubscriptionVersionSelectionComponent,
    StatusSelectionComponent,
    ReadonlyInputComponent,
    ClipboardCopyComponent
  ]
})
export class CommonLayoutModule { }
